import { useContext } from 'react';

import { Axis, DataContext } from '@visx/xychart';

import { useTickValues } from './useTickValues';
import { type AxisProps, DEFAULT_X_TICKS } from './utils';

import { useCursor } from '../cursor/useCursor';

import type { TickLabelProps } from '@visx/axis';

export const XAxis = <T,>({ tickFormat, numTicks = DEFAULT_X_TICKS, tickComponent }: AxisProps<T>) => {
  const { xTickValues } = useTickValues({ numXTicks: numTicks });
  const lastIndex = xTickValues ? xTickValues.length - 1 : -1;

  const cursorData = useCursor();
  const data = useContext(DataContext);
  const cursorTickValue = cursorData.nearestKey
    ? (data.dataRegistry?.get(cursorData.nearestKey).xAccessor(cursorData.data) as T)
    : undefined;

  const tickLabelProps: TickLabelProps<T> = (_value, index) => ({
    dy: 4,
    ...(!cursorTickValue && index === 0 && { textAnchor: 'start' as const }),
    ...(!cursorTickValue && index === lastIndex && { textAnchor: 'end' as const }),
  });

  return (
    <Axis
      hideAxisLine={true}
      orientation="bottom"
      tickValues={cursorTickValue ? [cursorTickValue] : xTickValues}
      tickFormat={tickFormat}
      hideTicks={true}
      tickLabelProps={tickLabelProps}
      tickComponent={tickComponent}
    />
  );
};
